$(document).ready(function() {

    // mapping scores
    if ($("#roundEdit").length || $("#eventEdit").length) {

      var newMappingCount = 0;

      // Add an initial new score mapping
      addMappingBin();
      $("#new-mapping-add").click(function(){
        addMappingBin();
        resetInputMasks();
      });
      $(".mapping-delete-button").click(function(){
        $("#mapping-"+$(this).attr("data-id")).remove();
      });

      function reloadBinOptions() {

          $(".mapping-bin").click(function() {
            console.log('bin click');
            $('.mapping-bins-edit').hide();
            var mappingId=$(this).attr('id').split('-')[2];
            $('#score-output-edit-'+mappingId).show();
            return false;
          })

          $('.score-output-save').click(function(){
            console.log('bin save');
            $('.mapping-bins-edit').hide();
            var mappingId=$(this).attr('id').split('-')[3];
            var scoreOutput = $('#score-output-input-' + mappingId).val();
            $('#mapping-bin-' + mappingId).attr('data-original-title', "Score output: " + scoreOutput);
            return false;
          });

          // $(".mapping-split").click(function() {
          //   console.log('split click');
          //   $('.mapping-bins-edit').hide();
          //   var mappingId=$(this).attr('id').split('-')[2];
          //   $('#bin-split-edit-' + mappingId).show();
          //   return false;
          // })

          // $('.bin-split-save').click(function(){
          //   console.log('split save');
          //   $('.mapping-bins-edit').hide();
          //   var mappingId=$(this).attr('id').split('-')[3];
          //   var split = $('#bin-split-input-' + mappingId).val();
          //   $('#mapping-split-' + mappingId).attr('data-original-title', split);
          //   return false;
          // });

          // splits a bin into two new bins
          // $('.bin-split').click(function(){
          //   console.log('bin split');
          //   var mappingId=$(this).attr('id').split('-')[2];
          //
          //   // calculates the split between the two new bins
          //   var previousSplit = $('#bin-split-edit-' + mappingId).children('input').val();
          //   var nextSplit = $('#bin-split-edit-' + mappingId).next('.score-output-edit').next('.bin-split-edit').children('input').val();
          //   var newSplit = ($(this) + nextSplit)/2;
          //
          //   var scoreOutput = $('#score-output-'+mappingId).val();
          //   console.log(['mapping id: '+mappingId,'previous split: '+previousSplit,'next split: '+nextSplit,'new split: '+newSplit]);
          //   //add buttons with tooltips with correct new split and same score_output
          //   $('#mapping-bin-'+mappingId).after('<button type="button" id="new_mapping-split-new' + newMappingCount + '" class="btn btn-warning mapping-split new-mapping-split" data-toggle="tooltip" data-placement="top" data-title="' + newSplit + '"></button><button type="button" id="new_mapping-bin-new' + newMappingCount + '" class="btn btn-success mapping-bin new-mapping-bin" type="button" data-toggle="tooltip" data-placement="bottom" data-title="Score output: ' + scoreOutput + '"></button>');
          //
          //   //add inputs for new mapping-split and mapping-bin
          //   $('#bin-split-edit-' + mappingId).after('<div id="bin-split-edit-new' + newMappingCount + '" class="mapping-bins-edit bin-split-edit"><label for="Split Location">Split Location</label><input id="bin-split-input-new' + newMappingCount + '" required type=number min=0 class="form-control" placeholder="Split" name="min_score_new_' + newMappingCount + '" type="text" value="10.0000"><a href="#" id="bin-split-save-new' + newMappingCount + '" class="btn btn-primary bin-split-save mt-2 float-right"> Save</a></div><div id="score-output-edit-new' + newMappingCount + '" class="mapping-bins-edit score-output-edit"><label for="Output Points">Output Points</label><input id="score-output-input-new' + newMappingCount + '" required type=number min=0 class="form-control" placeholder="Output Points" name="score_output_new_' + newMappingCount + '" type="text" value="2.0000"><a href="#" id="bin-split-new' + newMappingCount + '" class="btn btn-secondary bin-split mt-2 float-right"> Split Bin</a><a href="#" id="score-output-save-new' + newMappingCount + '" class="btn btn-primary score-output-save mt-2 float-right"> Save</a></div>');
          //
          //   newMappingCount +=1;
          //   reloadBinOptions();
          //   return false;
          // });
      }

      reloadBinOptions();

      function addMappingBin() {

        // Increment new mapping bin count for field names
        newMappingCount += 1;

        // Prepare the template
        var templateCode = $("#new-mapping-template").html();
        templateCode = templateCode.replace(/_VV/g, "_"+newMappingCount);

        // Inject the prepared template code
        $("#new-mappings").append(templateCode);
      }

// Start ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

          function populateScoreSettings() {

            var primaryIsTime = ($('input[name="scoring_primary_is_time"]:checked').val() == 1);
            var primaryDecimal = $("input[name=scoring_primary_decimal_places]").val();

            $("#mappings-edit").attr("data-time", primaryIsTime);
            $("#mappings-edit").attr("data-decimal", primaryDecimal);

            resetInputMasks();
          };

          populateScoreSettings();
          $("input[name=scoring_primary_is_time]").change(function() {
            populateScoreSettings();
          });
          //
          // $("input[name=scoring_primary_decimal_places]").change(function() {
          //   populateScoreSettings();
          // });

          // resets all scores on the page based on their data-attributes for each .score
          // NOTE: This function is also in app/global.js. If changed here, also change there.
          function resetInputMasks() {

            // read data-attr which stores round enable_custom_settings
            var isTime = $('#mappings-edit').attr("data-time")=='true';
            var decimalPlaces = $('#mappings-edit').attr("data-decimal");



            $('.mapping-edit').each(function() {
              var initialValue =$(this).val();

              var l = initialValue.split(":");
              var sum=0;
              for (var i = 0; i < l.length; i++) {
                sum+=parseFloat(l[i]);
              }

              var decimalString = "";
              if (decimalPlaces > 0) {
                decimalString += ".";
                for (var i = 0; i < decimalPlaces; i++) {
                  var decimalString = decimalString + '9';
                }
              }

              if(sum == 0){
                if (isTime) {
                  $(this).inputmask('remove');
                  $(this).inputmask("99:99:99" + decimalString, {
                    numericInput: true,
                    placeholder: "0",
                    setvalue: 0
                  });

                } else {
                  $(this).inputmask("9{1,8}" + decimalString, {
                    numericInput: true,
                    placeholder: "0",
                    setvalue: 0
                  });
                }

              }else {
                if (isTime) {
                  $(this).inputmask('remove');
                  $(this).inputmask("99:99:99" + decimalString, {
                    numericInput: true,
                    placeholder: "0",
                  });

                } else {
                  $(this).inputmask("9{1,8}" + decimalString, {
                    numericInput: true,
                    placeholder: "0"
                  });
                }
              }

              if(!sum==0){
                $(this).val(initialValue);
              }


            });
          }

// End ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    }

    if ($("#eventEdit").length) {
      var newMappingCount = 1;
      // CSS Copy
      $("#settingsSampleCSSCopyButton").click(function() {
        var copyCSS = $("#sample-css");
        copyCSS.focus();
        copyCSS.select();
        document.execCommand("Copy");
      });

    }
});
